
import { defineComponent } from "vue";

export default defineComponent({
  name: "AuthLoadingOverlay",
  props: {
    display: Boolean,
  },
});
